import React from 'react';
import { LockIcon, ZapIcon, ShieldIcon, CreditCardIcon } from 'lucide-react';
import { Section, CTAButton, CHECKOUT_URL, PRICE_USD, PRICE_USD_FULL } from './Shared';
const guarantees = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldIcon,
  label: 'Garantía de 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta y pago local'
}];
export const EmotionalClose = () => <Section className="max-w-4xl" data-id="element-28" data-mp="mmzjmekrgps6">
    <div className="glass-panel gold-frame p-7 md:p-14 rounded-sm text-center" data-id="element-29" data-mp="hmv2qnfxxt1f">
      <h2 className="text-2xl md:text-4xl font-display font-bold mb-3 text-brand-purpleDark leading-tight" data-id="element-30" data-mp="hoy3o2imt6kx">
        Hay dos versiones de ti en este momento.
      </h2>

      <div className="gold-rule my-7" aria-hidden="true" data-id="element-31" data-mp="7pytugm4r4wc">
        <span className="text-brand-gold text-[10px]" data-id="element-32" data-mp="2721kqbx331k1">◆</span>
      </div>

      <div className="space-y-5 text-base md:text-lg text-brand-text/85 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-33" data-mp="222f8o5szrrct">
        <p data-id="element-34" data-mp="352sk6dezk4za">
          Una que cierra esta página y, en la próxima sesión, sigue sin saber
          qué serie prescribir, cómo estructurar el encuentro ni cómo proteger
          su propio campo energético.
        </p>
        <p className="text-brand-purpleDark font-medium" data-id="element-35" data-mp="2v54rru4ur9ka">
          Y otra que decide que hoy es el día en que su práctica de Chi Kung
          cambia para siempre.
        </p>
        <p className="font-display italic text-lg md:text-xl text-brand-goldDark" data-id="element-36" data-mp="3ntadok7n74lp">
          La pregunta no es si puedes pagarlo.
          <br data-id="element-37" data-mp="3sr257d4dkopd" />
          La pregunta es cuántas sesiones más vas a trabajar sin un sistema
          clínico que te respalde.
        </p>
      </div>

      <div className="max-w-md mx-auto mb-10" data-id="element-38" data-mp="3e1cv2seb1acy">
        <div className="border border-brand-purpleDark/15 bg-brand-surfaceLight/40 rounded-sm p-7 text-center flex flex-col relative" data-id="element-39" data-mp="3j18u0d85abln">
          <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-brand-purpleDark text-brand-goldLight font-seal text-[9px] uppercase tracking-seal px-3 py-1" data-id="element-40" data-mp="ake03n9bs1jp">
            El más elegido
          </span>
          <h3 className="font-display font-bold text-xl text-brand-purpleDark mb-2 mt-3" data-id="element-41" data-mp="p6tdwdpketq7">
            Mega Pack Chi Kung
          </h3>
          <p className="text-sm text-brand-muted line-through" data-id="element-42" data-mp="g7pvzd24wkda">
            {PRICE_USD_FULL}
          </p>
          <p className="font-display font-bold text-4xl text-brand-purpleDark" data-id="element-43" data-mp="b8d062tac2yk">
            {PRICE_USD}
          </p>
          <p className="text-xs text-brand-muted mt-2 mb-4" data-id="element-44" data-mp="6bwbn7i6bmky">
            Pago único · El importe se aplica directamente en euros
          </p>
          <p className="text-sm text-brand-text/75 mb-6" data-id="element-45" data-mp="3spw83nhi0dde">
            3 tomos + 6 bonus · Más de 190 páginas. El sistema integral de
            sesiones prediseñadas y protección energética para el terapeuta
            profesional.
          </p>
          <CTAButton fullWidth className="text-xs md:text-sm py-4" href={CHECKOUT_URL} variant="purple" data-id="element-46" data-mp="3jnwqasynt59e">
            Quiero mi Mega Pack — {PRICE_USD}
          </CTAButton>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs md:text-sm text-brand-muted mb-10" data-id="element-47" data-mp="1z6xaiz2p6kya">
        {guarantees.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center" data-id="element-48" data-mp="244fmyzfxbib1">
            <Icon className="w-4 h-4 mr-1.5 text-brand-gold" data-id="element-49" data-mp="287bxs3z82a4f" /> {label}
          </span>)}
      </div>

      <div className="text-sm text-brand-text/85 border-t border-brand-gold/30 pt-7 space-y-3 max-w-2xl mx-auto" data-id="element-50" data-mp="1bjfnfgudob1n">
        <p data-id="element-51" data-mp="1gebhemj6d8he">
          <strong className="text-brand-purpleDark" data-id="element-52" data-mp="1kiawr1spy196">P.D.:</strong> si tienes
          dudas, escríbenos a{' '}
          <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-goldDark hover:underline font-medium" data-id="element-53" data-mp="1p8rakn0gbow2">
            soportelumenakasha@gmail.com
          </a>{' '}
          o a{' '}
          <a href="https://instagram.com/lumen.akasha" className="text-brand-goldDark hover:underline font-medium" data-id="element-54" data-mp="wrnbzfxpfh57">
            @lumen.akasha
          </a>
          . Te respondemos hoy mismo.
        </p>
        <p className="font-display italic text-brand-goldDark text-base" data-id="element-55" data-mp="8mw5nkmtungr">
          El precio de lanzamiento sube pronto. El mejor momento para tener tu
          sistema clínico de Chi Kung es ahora.
        </p>
      </div>
    </div>
  </Section>;